import { User, Workspace } from "@/components/graphql/schema.graphql";

interface WorkspaceFeatureFlags {
  showLabels?: boolean;
}

export type WorkspaceFeatureFlag = keyof WorkspaceFeatureFlags;

export interface UserFeatureFlags {
  showDevTools?: boolean;
  showBlueprintsNextRel?: boolean;
  referenceSetsEnabled?: boolean;
  workspaceModelsPolicyEnabled?: boolean;
}

export type UserFeatureFlag = keyof UserFeatureFlags;

export type FeatureFlag = UserFeatureFlag | WorkspaceFeatureFlag;

export type FeatureFlags = Record<FeatureFlag, boolean>;

const featureFlagMapping: {
  [key: string]: FeatureFlag;
} = {
  show_dev_tools: "showDevTools",
  show_labels: "showLabels",
  show_blueprints_next_rel: "showBlueprintsNextRel",
  reference_sets_enabled: "referenceSetsEnabled",
  workspace_models_policy_enabled: "workspaceModelsPolicyEnabled",
};

export const extractFeatureFlags = (
  userFeatureFlagList: User["featureFlags"],
  workspaceFeatureFlagList: Workspace["featureFlags"],
) => {
  // Workspace feature flags will override any user level ones if truthy
  return [...userFeatureFlagList, ...workspaceFeatureFlagList].reduce(
    (acc, flag) => {
      if (!flag) return acc;

      const key = featureFlagMapping[flag];
      if (key) {
        acc[key] = true;
      }

      return acc;
    },
    {} as FeatureFlags,
  );
};
